






















































import {Vue, Component} from 'vue-property-decorator';
import Footers from '@/components/Footers.vue';
import {GetAdminsTempServiceRequest} from 'supporter';
import Logo from '@/components/common/Logo.vue';

@Component({
  components: { Logo, Footers}
})

export default class RegisterCompletePage extends Vue {
  private tempCode = this.$route.query.tempCode;
  private adminId = '';
  private adminName = '';
  private jobPositionName = '';
  private phoneNo = '';
  private mobileNo = '';
  private serviceName = '';
  private status: boolean = false;

  private department = '';
  private departmentName = '';
  private jobDutyName = '';
  private departmentNo:number|null = null;
  private jobDutyNo:number|null = null;

  private mounted() {
    this.getCompleteInfo();
  }
  private destroyed() {
    $('#container').removeClass('layout_error');
    $('body').removeClass('error_page');
  }
  private onClickLoginButton() {
    location.href = '/login';
  }
  private back2Main() {
    this.$router.replace('/')
  }
  private getCompleteInfo() {
    let request = {
      params: {
        tempCode: this.tempCode as string
      }
    };
    this.$api.getAdminsTempService(request as GetAdminsTempServiceRequest).then(ret => {
      const status = ret.data.adminStatus;
      
      if (status === 'DELETE') {
        document.close();
        alert(window.$t('ADMIN_SERVICE_ALREADY_DELETE'));
        location.href = '/login';
      }
      this.adminId = ret.data.adminId;
      this.adminName = ret.data.adminName;
      this.jobPositionName = ret.data.jobPositionName;
      this.phoneNo = ret.data.contactInfo.phoneNo;
      this.mobileNo = ret.data.contactInfo.mobileNo;
      this.serviceName = ret.data.serviceName;
      this.departmentNo = ret.data.departmentNo;
      
      this.jobDutyNo = ret.data.jobDutyNo;

      if(this.departmentNo !== 0) {
        ret.data.departments.forEach(e => {
          if(Number(e.departmentNo) === Number(this.departmentNo)){
            this.departmentName = e.departmentName;
          }
        });
      }
      if(this.jobDutyNo !== 0){
         ret.data.jobDuties.forEach(e => {
          if(Number(e.jobDutyNo) === Number(this.jobDutyNo)){
            this.jobDutyName = e.jobDutyName;
          }
        });
      }
      if (this.departmentNo === 0 && this.jobDutyNo === 0 ) {
        this.department = null;
      } else if (this.departmentNo === 0 && this.jobDutyNo !== 0) {
        this.department = `(${this.jobDutyName})`;
      } else if (this.departmentNo !== 0 && this.jobDutyNo === 0) {
        this.department = `(${this.departmentName})`;
      } else {
        this.department = `(${this.departmentName} ${this.jobDutyName})`;
      }
    })
    .catch(() => {
      $('#container').removeClass('layout_agreeTerms');
      $('#container').addClass('layout_error');
      $('body').addClass('error_page');
      this.status = true;
    });
  }
}
